import NotFound from './NotFound.jsx';

export default NotFound;
